import { Container, Stack } from "@mui/material"

import ErrorComponent from "@/components/error"

import Page from "../components/Page"

export default function Page500() {
  return (
    <Container component="main">
      <Stack
        sx={{
          py: 12,
          m: "auto",
          maxWidth: 500,
          minHeight: "100vh",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <Page title="Something went wrong" sx={{ height: 1 }}>
          <ErrorComponent />
        </Page>
      </Stack>
    </Container>
  )
}
